<div class="card border-3 border-blue-500">
    <div *ngIf="data === undefined else elseBlock">

      <div class="flex justify-content-center flex-wrap">
        <div class="flex align-items-center justify-content-center"><p-progressSpinner></p-progressSpinner></div>
      </div>
    </div>

    <ng-template #elseBlock>
      <div class="grid">
        <div class="col-12">
          <p class="font-semibold text-center text-blue-500 text-4xl">Ventas mensuales por local</p>
        </div>
        <div class="col-6 col-offset-6">
        </div>
        <div class="col-12">
            <ami-line-chart
            [dataSeries]="data"
            [categories]="categories"
            [x_title]="x_title"
            [y_title]="y_title"
            [formatter]="formatter"
            [annotationSettings]="annotationSettings"
            [chartTitle]="chartTitle"
          >
          </ami-line-chart>
        </div>
      </div>

    </ng-template>

  </div>
